import { map, pluck, mergeMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { tag } from 'rxjs-spy/operators/tag'
import { walletTransferEvents } from '.'
import { walletApiConstants, walletApiEvents, walletApiSelectors, walletApiTransformers } from '../../../api/wallet'
import { of, zip } from 'rxjs'
import { pathOr } from 'ramda'
import { partyApiEvents } from '../../../api/party'
// import { walletApiConstants, walletApiTransformers } from '../../../api/wallet'

/**
 * - Lookup references
 * - Fetch balances
 * - Create wallet if to wallet doesn't exist
 * - return events which updates state and re-renders component for transfer confirmation
 *   - lookups
 *   - balances
 */
export const lookupReferencesAndMaybeCreateWallet = (action$: any, state$: any, { get, post, catchRestError }: any) =>
  action$.pipe(
    ofType(walletTransferEvents.walletLookup_request),
    // wallet reference lookups
    mergeMap(action => {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      const { from, to } = action.payload
      const lookup = (reference: any) =>
        get(walletApiConstants.ENDPOINTS.REFERENCE_LOOKUP, state$, { reference }).pipe(
          pluck('response'),
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          map(res => walletApiEvents.referenceLookup_success(res.result)),
          catchRestError(action),
        )

      // Balances are keyed by the wallet the funds actually sit in: the CW when the owner has
      // one, otherwise the NAL the lookup returned. The confirmation screen reads the same key.
      const fetchBalance = (lookupAction: any) => {
        const walletRef = walletApiSelectors.spendableWalletRef(lookupAction.payload)
        return get(walletApiConstants.ENDPOINTS.BALANCE, state$, { partyId: walletRef }).pipe(
          pluck('response'),
          map((res: any) =>
            walletApiEvents.balance_success(walletApiTransformers.transformBalance(res), {
              partyId: walletRef,
            }),
          ),
          catchRestError(lookupAction),
        )
      }

      return zip(lookup(from), lookup(to)).pipe(
        mergeMap(([fromWallet, toWallet]: any[]) => {
          if (!fromWallet?.payload?.walletRef || !toWallet?.payload?.walletRef) {
            return of([fromWallet, toWallet, walletTransferEvents.walletLookup_success()])
          }

          // fetch balances
          return zip(of(fromWallet), of(toWallet), fetchBalance(fromWallet), fetchBalance(toWallet)).pipe(
            mergeMap((res: any[]) => {
              const [, toWalletAction, , toBalance] = res
              const walletExists = pathOr(false, ['payload', 'globalBalance', 'exists'], toBalance)
              if (walletExists) {
                return of(res)
              }

              const createWallet$ = post(walletApiConstants.ENDPOINTS.CREATE_WALLET, state$, {
                account: toWalletAction.payload.accountId,
                agency: toWalletAction.payload.agencyId,
                party: toWalletAction.payload.partyId,
              }).pipe(
                pluck('response'),
                map((createRes: any) =>
                  walletApiEvents.createWallet_success(createRes, { walletRef: toWalletAction.payload.walletRef }),
                ),
                catchRestError(toWalletAction),
              )
              return zip(createWallet$, ...res.map((r: any) => of(r)))
            }),
          )
        }),
      )
    }),
    mergeMap((res: any) => res),
    tag('wallet/epics/lookupReferencesAndMaybeCreateWallet'),
  )
